import {
    SPORTSMEN_FAILURE,
    SPORTSMEN_REQUEST,
    SPORTSMEN_SUCCESS,
    SPORTSMEN_POST_SUCCESS,
    SPORTSMEN_DELETE_SUCCESS,
    SPORTSMEN_PATCH_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const sportsmenListReducer = (state = initialState, action) => {
    const { type, data, sportsman } = action;
    switch (type) {
        case SPORTSMEN_DELETE_SUCCESS: {
            const newData = state.data.filter(d => d.id !== sportsman)
            return {
                ...state,
                data: [...newData]
            }
        }

        case SPORTSMEN_PATCH_SUCCESS: {
            return {
                ...state,
                data: state.data.map(d => d.id === sportsman.id ? sportsman : d)
            }
        }

        case SPORTSMEN_POST_SUCCESS: {
            return {
                ...state,
                data: [...state.data, sportsman]
            }
        }

        case SPORTSMEN_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case SPORTSMEN_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case SPORTSMEN_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
